import intlResource from 'src/core/intl/intlResource';

import type { SupportedLocale } from 'src/core/intl/intlTypes';

const STORAGE_KEY = 'charity.locale';

const isSupportedLocale = (value: string | null): value is SupportedLocale =>
  !!value && intlResource.getSupportedLocales().includes(value);

// Accessing localStorage throws, not just returns null, in Safari private mode and
// wherever site data is blocked -- and this runs at boot, so it must never throw
export const getStoredLocale = (): SupportedLocale | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isSupportedLocale(stored) ? stored : null;
  } catch {
    return null;
  }
};

export const setStoredLocale = (locale: SupportedLocale): void => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // the language still changes for this session, it just is not remembered
  }
};
